export default {
  buttons: {
    apply: "Anwenden",
    cancel: "ABBRECHEN",
    dismiss: "Schließen",
    minimize: "Minimieren",
    unminimize: "Maximieren",
    add_waypoint: "Ziel hinzufügen"
  },
  distance: {
    value: "{distance, number, distance} {unit}"
  },
  send_to_phone: {
    mail: {
      body: "{url}"
    }
  },
  search: {
    title: "Suchen",
    placeholder: "Ort eingeben",
    enter_location: "Ort eingeben",
    recent_searches: "Letzte Suchanfragen",
    suggestions: "Vorschläge",
    help: {
      inactive: "Suchen"
    }
  },
  filters: {
    title: "Filter",
    more: "Mehr Filter",
    less: "Weniger Filter",
    group: {
      more: "Mehr",
      less: "Weniger"
    },
    amenities: {
      title: "Service Angebot"
    },
    fuels: {
      title: "verfügbare Kraftstoffe"
    },
    open_statuses: {
      title: "Öffnungszeiten"
    }
  },
  directions: {
    title: "Routenplaner",
    help: {
      add_waypoint: "Zwischenstation hinzufügen",
      reverse: "Umgekehrte Richtung",
      sort_waypoint: "Zur Neuanordnung ziehen",
      remove: "Zwischenstation entfernen"
    },
    placeholder: {
      origin: "Wählen Sie einen Startpunkt",
      destination: "Ort eingeben",
      waypoint: "Ort eingeben"
    },
    route: {
      title: "Routen Optionen",
      title_avoid: "Vermeiden",
      avoid_tolls: "Mautstraßen vermeiden",
      avoid_highways: "Autobahnen vermeiden",
      avoid_ferries: "Fähren vermeiden",
      title_corridor: "Entfernung Route zu Stationen"
    },
    travel_time: `\
{weeks, plural, =0 {} =1 {# Woche} other {# Wochen}}
{days, plural, =0 {} =1 {# Tag} other {# Tage}}
{hours, plural, =0 {} =1 {# Stunde} other {# Stunden}}
{minutes, plural, =0 {} =1 {# min} other {# min}}\
`,
    button: "Suchen",
    error: "Es gab ein Problem bei der Verarbeitung Ihrer Route. Bitte versuchen Sie es erneut."
  },
  action_panel: {
    back_to_results: "Zurück zu den Ergebnissen"
  },
  locations: {
    title: "Standorte",
    closed_temporarily: "Vorübergehend geschlossen",
    distance: "{distance, number, distance} {unit}",
    distance_from: "{distance, number, distance} {unit} von {place}",
    description: "{visible, select, true {Verbergen} false {Anzeigen} }"
  },
  open_now: {
    open_until: "Jetzt geöffnet: Bis {statusChangeTime, date, dateFormat}",
    open_24_hours: "24 Stunden ",
    closed_until: "Jetzt geschlossen: öffnet sich {statusChangeTime, date, dateFormat}"
  },
  info_window: {
    back_to_results: "Zurück zu den Ergebnissen",
    title: "Stationsdetails",
    location_id: "Stationsnummer",
    website: "Webseite",
    services: "Service Angebot",
    nearby: "Nahe bei",
    directions: "Zum Routenplaner hinzufügen",
    mobile: {
      telephone: "Tel."
    },
    opening_hours: {
      title: "Öffnungszeiten",
      mon: "Mo",
      tue: "Di",
      wed: "Mi",
      thu: "Do",
      fri: "Fr",
      sat: "Sa",
      sun: "So",
      open_twentyfourhours: "24 Stunden ",
      period: "{start, time, short} – {end, time, short}"
    },
    fuel_prices: {
      available: "Kraftstoffe mit Preisanzeige verfügbar",
      not_available: "Kraftstoff verfügbar",
      price: "{price, number, fuelPrice}",
      disclaimer: "Alle Angaben ohne Gewähr. Nur die Preise an der Zapfsäule sind gültig.",
      last_updated_on: "Letzte Aktualisierung",
      timestamp: "{timestamp, date, dateFormat}"
    }
  },
  itinerary: {
    title: "Routenplaner"
  },
  fuels: {
    autogas_lpg: "Shell AutoGas (LPG)",
    cng: "Shell Erdgas (CNG)",
    fuelsave_midgrade_gasoline: "Shell Super FuelSave E10",
    fuelsave_regular_diesel: "Shell Diesel FuelSave",
    hydrogen: "Shell Wasserstoff (Hydrogen)",
    midgrade_gasoline: "Shell Super FuelSave 95",
    premium_diesel: "Shell V-Power Diesel",
    super_premium_gasoline: "Shell V-Power Racing",
    truck_diesel: "Shell Fuelsave Truck Diesel"
  },
  amenities: {
    air_and_water: "Luft",
    atm: "Geldautomat",
    austrian_highway_sticker: "Autobahn Vignette Österreich",
    bakery_shop: "Backshop/Kaffee",
    carwash: "Waschanlage",
    clubsmart_card: "Shell CLUBSMART ",
    conveyor_and_jet: "Waschstraße und SB Wash",
    conveyor: "Waschstraße",
    credit_card_american_express: "Kreditkarte - American Express",
    credit_card_diners_club: "Kreditkarte - Diners Club",
    credit_card_mastercard: "Kreditkarte - Mastercard",
    credit_card_visa: "Kreditkarte - Visa",
    credit_card: "Kreditkarte",
    czech_highway_sticker: "Autobahn Vignette Tschechien",
    euroshell_card: "euroShell",
    fleet_card_dkv: "Flottenkarte - DKV",
    fleet_card_eni: "Flottenkarte - Eni",
    fleet_card_esso: "Flottenkarte - Esso",
    fleet_card_general: "Flottenkarte",
    fleet_card_uta: "Flottenkarte - UTA",
    food_offerings: "Shop Angebote",
    fuel_card: "Tankkarte",
    full_service: "Shell Tankwart-Service",
    guarded_car_park: "Bewachter Parkplatz",
    hgv_lane: "LKW tauglich",
    high_speed_diesel_pump: "Hochleistungs Diesel-Zapfsäule",
    hot_food: "Imbiss",
    hungarian_highway_sticker: "Autobahn Vignette Ungarn",
    jet: "SB Wash",
    loyalty_cards: "ClubSmart Karte",
    manual: "Manuell",
    maut_terminal: "Maut Terminal",
    mobile_payment: "Shell SmartPay",
    motorway_service: "Autobahn Service",
    navigator_fleet_loyalty_discount: "ClubSmart Rabatt",
    others: "Sonstige",
    parking_lanes: "Parkplatz",
    partner_card: "Partner Karte",
    pay_at_pump: "An der Säule bezahlen",
    rollover_and_jet: "Portalwaschanlage und SB Wash",
    rollover: "Portalwaschanlage und SB Wash",
    self_service: "Selbstbedienung",
    service_bay: "Reparatur Halle",
    shell_card: "euroShell",
    shell_club_smart_extra_card: "Shell V-Power Club",
    shower: "Dusche",
    slovak_highway_sticker: "Autobahn Vignette Slowakei",
    snack_food: "Imbiss",
    standard_toilet: "WC",
    supermarket_fuel_discount: "Kraftstoff Rabatt",
    toilet: "WC",
    truck_parking: "LKW Parkplatz",
    truckport: "Nur LKW",
    twenty_four_hour: "24-Stunden",
    twotheloo: "WC",
    unmanned: "Automaten Station",
    vacuum: "Staubsauger",
    adblue_truck: "LKW AdBlue ab Pumpe",
    adblue_car: "PKW AdBlue ab Pumpe",
    adblue_pack: "AdBlue Gebinde im Shop"
  },
  open_statuses: {
    open_now: "Jetzt geöffnet"
  },
  settings: {
    title: "Einstellungen",
    tooltip: "Einstellungen",
    traffic: "Verkehr",
    distance_units: {
      title: "Maßeinheit",
      km: "Kilometer",
      miles: "Meilen"
    },
    language: {
      title: "Sprache"
    }
  }
}
